import classNames from "classnames";
import { Icon } from "semantic-ui-react";
import styles from "./CardSessionStatus.module.scss";
import { type CompletionStatus } from "features/Flows/types/enums";
import { useTranslation } from "react-i18next";
import { EntityType } from "features/common/types";
import { TextTruncator } from "features/Application/layout/TextTruncator/TextTruncator";

const cx = classNames.bind(styles);

type Props = { status: CompletionStatus; entityType: EntityType };

type Color = "gray" | "yellow" | "green";

export const CardSessionStatus = (props: Props) => {
  const { t } = useTranslation(["application"]);
  const statusToColor: Record<CompletionStatus, Color> = {
    0: "gray",
    1: "yellow",
    2: "green",
  };

  const color: Color = statusToColor[props.status];

  const eventHandler = (status: CompletionStatus): string => {
    if (status === 0) return t("progressBars.notRegistered");
    if (status === 1) return t("progressBars.registered");
    return t("progressBars.Attended");
  };

  const defaultHandler = (status: CompletionStatus): string =>
    status === 1 ? t("progressBars.inProgress") : t("progressBars.completed");

  const textHandlers: Partial<Record<EntityType, (status: CompletionStatus) => string>> = {
    [EntityType.Event]: eventHandler,
    [EntityType.UpcomingEvent]: eventHandler,
    [EntityType.Pdf]: () => t("progressBars.viewed"),
  };

  const text = (textHandlers[props.entityType] || defaultHandler)(props.status);

  return (
    <div className={cx(styles.root, styles[`${color}`])}>
      <Icon className="circle" />
      <TextTruncator
        tooltipContent={text.toLocaleUpperCase()}
        clamp={1}
        tabIndex={-1}
        aria-label={text.toLocaleUpperCase()}
      >
        {text.toLocaleUpperCase()}
      </TextTruncator>
    </div>
  );
};
